import React, { useEffect } from "react";
import { TourProvider, useTour } from "@reactour/tour";
import MsxIcons from "../../Common/components/Icons/MsxIcons/MsxIcons";

const GuidedTour = ({ steps, setIsTourEnabled }) => {
  return (
    <TourProvider
      showBadge={false}
      startAt={0}
      steps={steps}
      scrollSmooth
      styles={tourStyles}
      prevButton={PrevButton}
      nextButton={NextButton}
      onClickMask={({ setIsOpen }) => {
        setIsOpen(false);
        setIsTourEnabled(false);
      }}
      onClickClose={({ setIsOpen }) => {
        setIsOpen(false);
        setIsTourEnabled(false);
      }}
      keyboardHandler={(e, clickProps) => {
        if (e.key === "ArrowRight") {
          clickProps.setCurrentStep(Math.min(clickProps.currentStep + 1, clickProps.steps.length - 1));
        }
        if (e.key === "ArrowLeft") {
          clickProps.setCurrentStep(Math.max(clickProps.currentStep - 1, 0));
        }
        if (e.key === "Escape") {
          setIsTourEnabled(false);
        }
      }}
    >
      <Tour />
    </TourProvider>
  );
};
const PrevButton = ({ currentStep, setCurrentStep }) => {
  const first = currentStep === 0;
  return (
    <button
      onClick={() => {
        if (!first) {
          setCurrentStep((s) => s - 1);
        }
      }}
    >
      <div
        className={`border flex items-center justify-center rounded-md space-x-1 ${first ? "" : "border-[#626469]"}`}
      >
        <div className="ml-0" />
        <MsxIcons name="arrow-left" size="nano" className={`mb-[1px] ${first ? "" : "border-[#626469]"}`} />
        <div className={`${first ? "text-[#626469]" : ""} mb-1`}>Previous</div>
        <div />
        <div />
      </div>
    </button>
  );
};

const NextButton = ({ currentStep, stepsLength, setCurrentStep, steps }) => {
  const last = currentStep === stepsLength - 1;
  return (
    <button
      onClick={() => {
        if (!last) {
          setCurrentStep((s) => (s === steps?.length - 1 ? 0 : s + 1));
        }
      }}
    >
      <div className={`border flex items-center justify-center rounded-md space-x-1 ${last ? "" : "border-[#626469]"}`}>
        <div className="ml-2" />
        <div className={`${last ? "text-[#626469]" : ""} mb-1`}>Next</div>
        <MsxIcons name="arrow-right" size="nano" className={`mb-[1px] ${last ? "" : "border-[#626469]"}`} />
        <div className="mr-3" />
      </div>
    </button>
  );
};

const tourStyles = {
  popover: (base) => ({
    ...base,
    "border-radius": "0.375rem",
    "--reactour-accent": `rgba(var(--color-primary), var(--tw-bg-opacity))`
  }),
  close: (base) => ({ ...base, right: 8, left: "auto", top: 8 })
};

const Tour = () => {
  const { setIsOpen } = useTour();

  useEffect(() => {
    setIsOpen(true);
  }, [setIsOpen]);

  return null;
};

export default GuidedTour;
